/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { Localization } from 'connex-cds';

export const useAllDateOptions = () => {
  const translateMessage = Localization?.useTranslateMessage?.();

  return [
    {
      value: 'Yesterday',
      token: translateMessage?.('dateSelector_yesterday'),
    },
    {
      value: 'Today',
      token: translateMessage?.('dateSelector_today'),
    },
    {
      value: 'Tomorrow',
      token: translateMessage?.('dateSelector_tomorrow'),
    },
    {
      value: 'Last_7_Days',
      token: translateMessage?.('dateSelector_last_week'),
    },
  ];
};
